import React from 'react';
import { WarningEmptyResults } from '@yme/assets/icons';
import { SVGIcon, ICON_SIZE } from '@yme/atoms/svg-icon';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { DescriptionStyled } from './styled';
export const NoResultComponent = ({ noResultTitle, noResultDescription, }) => (React.createElement(React.Fragment, null,
    React.createElement(SVGIcon, { type: WarningEmptyResults, size: ICON_SIZE.xxl }),
    React.createElement(FlexWrapper, { gap: "4px", flexDirection: "column", alignItems: "center" },
        noResultTitle && React.createElement(RegularTextLevel3, { weight: 500 }, noResultTitle),
        noResultDescription && (React.createElement(DescriptionStyled, { color: colorCoreBlack300 }, noResultDescription)))));
